import { newOpenwinLoadOption } from "./jkClass";
import { OpenWinLoadOption } from "./jkInterface";
import { jkLib } from "./jkCommon";
import { ChangeDetectorRef, inject } from "@angular/core";
import { OrmService } from "./jkOrm";

// 自訂功能先放init()裡, 要用rxjs 都不要用await
export class JkBaseOption {
  orm: OrmService= inject(OrmService);
  // 供 subscribe()/setTimeout() 等非同步更新欄位後手動觸發變更檢測 (OnPush/zoneless)
  cdr = inject(ChangeDetectorRef);
  // 頁選項祖先
  name: string;
  openwinLoadOpts: OpenWinLoadOption[] = [];
  //colCount: number = 1;
  //colCountByScreen: Object;

  constructor(name: string, isForceInit: boolean = false) {
    this.name = name;
    /*this.colCountByScreen = {
      md: 3,
      sm: 2,
    };*/
    this.load(isForceInit);
    //this.initRx();
  }
  //initRx() {}
  save() {
    //
    if (!this.name) return;
    jkLib.saveLocalStorageItem(this.name, this);
  }
  //async init(): Promise<void> {}
  init() {}
  //async load(isForceInit: boolean = false) {
  private load(isForceInit: boolean = false) {
    let obj = {};
    if (isForceInit) {
      this.init();
    } else {
      if (!this.name) return;
      if (jkLib.loadLocalStorageItem(this.name, obj)) {
        jkLib.cloneField(obj, this);
      } else {
        //await this.init();  // jackie 20240730
        this.init();
      }
    }
  }
  screen(width: number) {
    return width < 720 ? 'sm' : 'md';
  }
  /*setColCount(width: number) {
    this.colCount = width < 720 ? 1 : 2;
    // console.log('width,colCount:', width, this.colCount);
  }*/

  addOpenwinLoadOption(
    mainTable: string,
    item: string,
    type: string,
    param: any[],
    list: any
  ) {
    let n = newOpenwinLoadOption(mainTable, item, type, param, list);
    this.openwinLoadOpts.push(n);
  }
}

/*
export class JkJobOption {
  name: string = '';
  caption: string= '';
  ps: string= '';
  kind: string= ''; // TComboBox,TjkComboBox TJKRange : A +"～"+ B
  //TCheckBox,TjkCheckBox: Y/N  TJKBtnEdit,TEdit,TJKDBEdit:text TjkMultiSelect: A||B...
  type: string= ''; // TComboBox,TjkComboBox TJKRange : A +"～"+ B
  data: string= ''; // combobox:itemIndex+1
}*/



